export interface PersistChannelDetailsArgs {
  channelId: string;
  description: string;
  businessRules: string;
  updateChannel: (channelId: string, data: Record<string, string>) => Promise<unknown>;
  showWarning: (message: string) => void;
}

export interface PersistChannelDetailsResult {
  persisted: boolean;
  payload?: Record<string, string>;
}

/**
 * Persists the user-entered description and business rules for a channel.
 * Returns whether an update was attempted, which keeps the caller logic easy to test.
 */
export async function persistChannelDescriptionAndRules(
  args: PersistChannelDetailsArgs
): Promise<PersistChannelDetailsResult> {
  const description = args.description.trim();
  const businessRules = args.businessRules.trim();
  const payload: Record<string, string> = {};

  if (description) {
    payload.channel_description = description;
  }

  if (businessRules) {
    payload.channel_business_rules = businessRules;
  }

  if (Object.keys(payload).length === 0) {
    return { persisted: false };
  }

  try {
    await args.updateChannel(args.channelId, payload);
    return { persisted: true, payload };
  } catch (error) {
    console.error('Failed to persist channel description/business rules:', error);
    args.showWarning('Channel connected, but description/rules could not be saved — edit the channel to retry.');
    return { persisted: false, payload };
  }
}
